export default __webpack_public_path__ + "_/images/bonuses/header/gift-57c3cc795d04c35e7fa5900784a1b5a5d90181816831dfe0b95bc7f2c62e0dfc.png";